import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  createFilterOptions,
  Tooltip,
  ListSubheader,
  InputAdornment,
  Tabs,
  Tab,
  CircularProgress
} from '@mui/material';
import styled from '@emotion/styled';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  addManagers,
  deleteEmployeeDocumentsById,
  deleteManagers,
  deleteSkillsUser,
  getAllBanks,
  getAllBillingRoles,
  getAllEmployees,
  getEmployeeById,
  getEmployeeDesignationHistory,
  getEmployeeDocsById,
  getEmployeeImagesById,
  getEmployeeManagers,
  getSkillsUser,
  updateEmployeeInformation,
  uploadEmployeeDocsById,
  uploadEmployeeImageById,
  getAllGenders,
  getAllMartialStatus,
  getResignationInformation,
  getDocumentAcknowledgements,
  updateDocumentAcknowledgements,
  updateDocumentAcknowledgementStatus,
  getAllReportingManagers
} from 'src/services/employeeService';
import {
  EmployeeDesignationHistory,
  EmployeeInformation,
  EmployeeResignationDetails,
  UpdateEmployee
} from 'src/models/employee';
import MuiPhoneNumber from 'material-ui-phone-number';
import Timeline from '@mui/lab/Timeline';
import { getAllRoles } from 'src/services/RoleManagementService';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import { SnackBar as SnackBarOld } from 'src/components/SnackBar';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import './Employee.css';
import EmployeePromoteForm from './EmployeePromoteForm';
import { AppActions } from 'src/store/AppReducer';
import CancelIcon from '@mui/icons-material/Cancel';
import SortableTree from 'react-sortable-tree';
import EmployeeResignation from './components/Resignation/EmployeeResignation';
import Rating from '@mui/material/Rating';
import CircleIcon from '@mui/icons-material/Circle';
import SkillsAddModal from './components/SkillsAdd/SkillsAddModal';
import moment from 'moment';
import { getRoleEmployeePermissions } from 'src/services/authService';
import { changeStringLength } from 'src/utils/stringFormat';
import { useAppSelector } from 'src/hooks/hooks';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { DatePicker } from '@mui/lab';
import { withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Multiselect from 'multiselect-react-dropdown';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import UnAuthorizedModal from '../common/unAuthorizedModal/UnAuthorizedModal';
import EmployeeProjectDetails from './components/ProjectDetails/EmployeeProjects';
import EmployeeLeaveSection from './components/LeaveHistory/EmployeeLeaveTab';
import ExamResults from './components/exam-results';
import ViewEventAttendee from './components/Event/ViewEventAttendee';
import AcknowledgementTask from 'src/content/employeeOnboarding/PreOnboarding/components/AcknowledgementTask';
import { decryptResponseData } from 'src/utils/cryptoUtils';


interface EmployeeEditProps {}
const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#1bc47d'
  },
  '& .MuiRating-iconHover': {
    color: '#1bc47d'
  }
});

const filter = createFilterOptions<any>();

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

const EMPLOYEE_TYPE_OPTIONS = [
  { value: 'Permanent' },
  { value: 'Probation' },
  { value: 'Intern' }
];

const normalizeEmployeeTypeValue = (type?: string): string => {
  if (!type) return '';
  const normalized = type.trim().toLowerCase();
  const match = EMPLOYEE_TYPE_OPTIONS.find(
    (option) => option.value.toLowerCase() === normalized
  );
  return match?.value || '';
};

const EmployeeEditForm: FC<EmployeeEditProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { employeeId } = useParams();
  let query = useQuery();
  let designationsInitial: EmployeeDesignationHistory[] = [];

  const [open, setOpen] = useState(false);

  const [openResignation, setOpenResignation] = useState(false);
  const [unauthorized, setUnauthorized] = useState(false);
  const [userRoles, setUserRoles] = useState<any>([]);
  const [visibility, setVisibility] = useState('');

  const [showEmployeeNumber, setShowEmployeeNumber] = useState(false);
  
  const [isExpandAcknowledgement, setIsExpandAcknowledgement] =
    useState<boolean>(false);
  const [ackTask, setAckTask] = useState<any>(null);
  const [ackItems, setAckItems] = useState<any[]>([]);
  const [ackComment, setAckComment] = useState('');
  const [ackSaving, setAckSaving] = useState(false);
  const [ackLoading, setAckLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState<string>('');
  const timeLeftRef = useRef<string>('');
  const [lastKnownAckDueDate, setLastKnownAckDueDate] = useState<string | null>(null);
  const frozenAckTimerStorageKey = `employee-ack-frozen-timer-${employeeId || 'unknown'}`;

  const setFrozenAckTimer = (value: string) => {
    try {
      localStorage.setItem(frozenAckTimerStorageKey, value || '');
    } catch {
      // ignore localStorage write failures
    }
  };

  const clearFrozenAckTimer = () => {
    try {
      localStorage.removeItem(frozenAckTimerStorageKey);
    } catch {
      // ignore localStorage removal failures
    }
  };

  const canEditAcknowledgement = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.EmployeeId === employeeId;
  };

  const isAckReadOnly =
    ackTask?.status === 'COMPLETED' || !canEditAcknowledgement();

  const [ackStatusUpdating, setAckStatusUpdating] = useState(false);

  const [tabValue, setTabValue] = useState<number>(1);

  useEffect(() => {
    setVisibility(query.get('view'));
  }, [query]);

  useEffect(() => {
    if (employeeId) {
      fetchDocumentAcknowledgements();
    }
  }, [employeeId]);

  const toggleResignation = () => {
    setOpenResignation(!openResignation);
  };

  const [empName, setEmpName] = useState('');
  const [employeeInformation, setEmployeeInformation] = useState(
    {} as UpdateEmployee
  );

  var initalList: EmployeeInformation[] = [];
  var [employeeList, setEmployees] = useState(initalList);
  const [primaryManager, setPrimaryManager] = useState<any>({});
  const [previousPrimaryManager, setPreviousPrimaryManager] =
    useState<string>('');
  const [secondaryManager, setSecondaryManager] = useState<any>({});
  const [additionalManager, setAdditionalManager] = useState<any>({});
  const [designation, setEmployeeDesigntionHistory] =
    useState(designationsInitial);
  const [emplyeeImages, setEmplyeeImages] = useState([]);
  const [employeeAttachments, setEmployeeAttachments] = useState([]);
  const [tableId, settableId] = useState('');
  const [attachment, setAttachment] = useState<any>({});
  const [image, setImage] = useState<any>({});
  const [reversedDesignation, setreversedDesignation] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const { register, handleSubmit, reset, setValue } = useForm<UpdateEmployee>();

  const [billingRoles, setBillingRoles] = useState<any>([]);

  const [genders, setAllGenders] = useState([]);
  const [maritalStatus, setAllMaritalStatus] = useState([]);

  const [genderValue, setGenderValue] = useState('');
  const [maritalStatusValue, setMaritalStatusValue] = useState('');
  const [resignationDetails, setResignationDetails] =
    useState<EmployeeResignationDetails | null>(null);

  const [employeeTypeValue, setEmployeeTypeValue] = useState('');
  const [employeeTypeStartingDateValue, setEmployeeTypeStartingDateValue] =
    useState('');
  const [employeeTypeEndingDateValue, setEmployeeTypeEndingDateValue] =
    useState('');
  const [startingDateError, setStartingDateError] = useState('');
  const [startingDateValue, setStartingDateValue] = useState('');
  const [endingDateValue, setEndingDateValue] = useState('');
  const [isChangeStartDate, setIsChangeStartDate] = useState(false);
  const [isChangeEndDate, setIsChangeEndDate] = useState(false);
  const [previousEmployeeType, setPreviousEmployeeType] = useState<string>('');
  const [employeeTypeError, setEmployeeTypeError] = useState<string>('');
  const [reportingManagerError, setReportingManagerError] =
    useState<string>('');
  const [reportingManager, setReportingManager] = useState<string>('');

  const employeeType = EMPLOYEE_TYPE_OPTIONS;

  const oneYearAfter = new Date();
  oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

  const newDesignationArray = reversedDesignation.map((obj) => {
    return {
      ...obj,
      name: obj.name,
      startedDate: obj.startedDate,
      endDate: obj.endDate,
      duration: obj.duration,
      endDateByOrder: obj.endDate ? obj.endDate : oneYearAfter
    };
  });

  const sortEndDates = newDesignationArray
    .map((obj) => {
      return { ...obj, endDateByOrder: new Date(obj.endDateByOrder) };
    })
    .sort((a, b) => b.endDateByOrder - a.endDateByOrder);

  const isIndustrialExperienceValid = (value?: string) => {
    const regex = /^\d+[Yy] \d+[Mm]$/;
    if (!value) {
      return false;
    }
    return value.length < 21 && regex.test(value);
  };

  useEffect(() => {
    if (visibility === 'false') {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [visibility]);

  useEffect(() => {
    getAllBillingRoles().then((res) => setBillingRoles(res.data));
    getAllGenderDetails();
    getAllMartialStatusDetails();
  }, []);

  const convertPhoneNumber = (pNumber: string) => {
    if (pNumber == undefined) return;

    let convertedNum = pNumber;
    convertedNum = convertedNum.replace(/\s/g, '');
    if (convertedNum.length === 9) {
      convertedNum = `0${convertedNum}`;
    }
    if (convertedNum.length === 10) {
      convertedNum = convertedNum.replace('0', '+94');
    }

    return convertedNum;
  };

  const getEmplyeeDetails = () => {
    getEmployeeById(employeeId)
      .then((res) => {
        const financeData = res?.data?.employeeFinance;
        const bankData = financeData?.employeeBankInformations[0];
        let allData = res?.data;
        allData.maritalStatus =
          allData?.maritalStatus?.charAt(0).toUpperCase() +
          allData?.maritalStatus.slice(1);
        allData.phoneNumber = convertPhoneNumber(allData.phoneNumber);
        allData.emergencyPhoneNumber = convertPhoneNumber(
          allData.emergencyPhoneNumber
        );
        allData.bankName = bankData?.bankName;
        allData.branch = bankData?.branchName;
        allData.branchCode = bankData?.branchCode;
        allData.accountNumber = bankData?.accountNumber;
        allData.accountName = bankData?.accountName;
        allData.employeeTypeEndingDate = financeData?.employeeTypeEndingDate;
        allData.employeeTypeStartingDate =
          financeData?.employeeTypeStartingDate;
        allData.type = financeData?.type;
        allData.updatedEmployeeNumber = res?.data?.employeeNumber;

        if (financeData?.isResign) {
          getResignationInformation(employeeId).then((res) => {
            if (res?.data != null) {
              setResignationDetails(res?.data as EmployeeResignationDetails);
            }
          });
        }

        setEmployeeInformation(allData as UpdateEmployee);
        setBankValue(allData.bankName);
        setEmpName(res.data.name);

        setGenderValue(allData.gender);
        setMaritalStatusValue(allData.maritalStatus);
        setEmployeeTypeValue(normalizeEmployeeTypeValue(allData.type));
        setPreviousEmployeeType(normalizeEmployeeTypeValue(allData.type));
        setStartingDateValue(
          allData?.employeeTypeStartingDate ? allData?.employeeTypeStartingDate?.split('T')[0] == '0001-01-01'
            ? ''
            : moment(allData?.employeeTypeStartingDate).format('YYYY-MM-DD')
            : ''
        );
        setEndingDateValue(
          allData?.employeeTypeEndingDate ? allData?.employeeTypeEndingDate?.split('T')[0] == '0001-01-01'
            ? ''
            : moment(allData?.employeeTypeEndingDate).format('YYYY-MM-DD')
            : ''
        );
        setEmployeeTypeStartingDateValue(
          allData?.employeeTypeStartingDate ? allData?.employeeTypeStartingDate?.split('T')[0] == '0001-01-01'
            ? ''
            : moment(allData?.employeeTypeStartingDate).format('YYYY-MM-DD')
            : ''
        );
        setEmployeeTypeEndingDateValue(
          allData?.employeeTypeEndingDate ? allData?.employeeTypeEndingDate?.split('T')[0] == '0001-01-01'
            ? ''
            : moment(allData?.employeeTypeEndingDate).format('YYYY-MM-DD')
            : ''
        );
        setCarrierStartDate(
          moment(allData?.carrierStartDate).format('YYYY-MM-DD')
        );

        dispatch(AppActions.hideLoader());
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
      });

    getEmployeeDesignationHistory(employeeId).then((res) => {
      setEmployeeDesigntionHistory(res.data as EmployeeDesignationHistory[]);
    });
  };

  const getUserRoles = async () => {
    const roles = await getAllRoles();
    setUserRoles(roles?.data);
  };

  const getReportingManagers = async () => {
    try {
      const res = await getAllReportingManagers();
      const decryptedData: any = await decryptResponseData(res.data);
      setEmployees(
        (decryptedData?.employees as EmployeeInformation[]) || []
      );
    } catch (error) {
      console.error('Error fetching reporting managers:', error);
    }
  };

  const getAllGenderDetails = () => {
    getAllGenders().then((res) => {
      setAllGenders(
        res?.data.map((ele) => {
          return { title: ele.name, id: ele.id };
        })
      );
    });
  };

  const getAllMartialStatusDetails = () => {
    getAllMartialStatus().then((res) => {
      setAllMaritalStatus(
        res?.data.map((ele) => {
          return { title: ele.name, id: ele.id };
        })
      );
    });
  };

  const fetchDocumentAcknowledgements = async () => {
    try {
      setAckLoading(true);
      const response = await getDocumentAcknowledgements(employeeId);

      if (response?.data?.success && response.data.data) {
        const apiData = response.data.data;

        const mappedTask = {
          id: apiData.employee_id,
          name: 'Document Acknowledgement',
          status: apiData.document_acknowledgement_status || 'TO_DO',
          expectedCompletionAt: apiData.expected_completion_at,
          comment: apiData.document_acknowledgement_comment || '',
          sla: apiData.sla,
          createdDate: apiData.created_date
        };

        const mappedItems = apiData.documentAcknowledgements.map(
          (doc: any) => ({
            id: doc.document_id,
            name: doc.name,
            status: doc.is_acknowledged ? 'COMPLETED' : 'TO_DO',
            documentUrl: doc.link,
            acknowledged: doc.is_acknowledged 
          })
        );

        setAckTask(mappedTask);
        setAckItems(mappedItems);
        setAckComment(apiData.document_acknowledgement_comment || '');
      }
    } catch (error) {
      console.error('Failed to fetch document acknowledgements:', error);
      dispatch(
        AppActions.toggleSnackBarOpen({
          message: 'Failed to load document acknowledgements.',
          severity: 'error'
        })
      );
    } finally {
      setAckLoading(false);
    }
  };

  const determineTaskStatus = (documents: any[], comment: string | null) => {
    const acknowledgedCount = documents.filter(
      (doc) => doc.is_acknowledged // Fix: Use is_acknowledged instead of acknowledged
    ).length;
    const totalCount = documents.length;

    if (acknowledgedCount === totalCount && comment) {
      return 'COMPLETED';
    } else if (acknowledgedCount > 0) {
      return 'IN_PROGRESS';
    } else {
      return 'TO_DO';
    }
  };

  const handleAcknowledgementSave = async (payload: {
    checked: Record<string, boolean>;
    comment: string;
  }) => {
    if (!ackTask || !canEditAcknowledgement()) return;

    try {
      setAckSaving(true);

      const updatePayload = {
        employeeId: employeeId,
        document_acknowledgement_comment: payload.comment,
        documentAcknowledgements: Object.entries(payload.checked).map(
          ([id, checked]) => ({
            document_id: parseInt(id),
            is_acknowledged: checked
          })
        )
      };

      await updateDocumentAcknowledgements(employeeId, updatePayload);

      // Check if all documents are acknowledged and comment is provided
      const allAcknowledged = Object.values(payload.checked).every(
        (checked) => checked
      );
      const hasComment = payload.comment.trim().length > 0;

      // Auto-complete if all conditions are met
      if (allAcknowledged && hasComment && ackTask.status !== 'COMPLETED') {
        await updateDocumentAcknowledgementStatus(employeeId, 'COMPLETED');
      }

      await fetchDocumentAcknowledgements();

      dispatch(
        AppActions.toggleSnackBarOpen({
          message: 'Document Acknowledgment is successful.',
          severity: 'success'
        })
      );

      if (allAcknowledged && hasComment) {
        console.log(
          'All documents acknowledged. Notification can be sent to HR.'
        );
      }
    } catch (error) {
      console.error('Failed to save acknowledgement:', error);
      dispatch(
        AppActions.toggleSnackBarOpen({
          message:
            'Failed to complete document acknowledgment. Please try again.',
          severity: 'error'
        })
      );
    } finally {
      setAckSaving(false);
    }
  };

  const handleAcknowledgementStatusChange = async (newStatus: string) => {
    if (!canEditAcknowledgement()) return;

    try {
      setAckStatusUpdating(true);

      if (newStatus === 'ON_HOLD' && timeLeftRef.current) {
        // Preserve full timer text (e.g. "4d 04:28:00") while ON_HOLD.
        setFrozenAckTimer(timeLeftRef.current);
      }

      if (newStatus !== 'ON_HOLD') {
        clearFrozenAckTimer();
      }

      await updateDocumentAcknowledgementStatus(employeeId, newStatus);

      // Refresh data to get updated status
      await fetchDocumentAcknowledgements();

      dispatch(
        AppActions.toggleSnackBarOpen({
          message: `Document acknowledgement status updated to ${newStatus
            .replace('_', ' ')
            .toLowerCase()}.`,
          severity: 'success'
        })
      );
    } catch (error) {
      console.error('Failed to update status:', error);
      dispatch(
        AppActions.toggleSnackBarOpen({
          message: 'Failed to update status. Please try again.',
          severity: 'error'
        })
      );
    } finally {
      setAckStatusUpdating(false);
    }
  };

  const handleAcknowledgementClear = async () => {
    await fetchDocumentAcknowledgements();
  };

  const [skillsSet, setSkillsSet] = useState([]);
  const [openSkillAddModal, setOpenSkillAddModal] = useState(false);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const toggleSkillsAdd = () => {
    setOpenSkillAddModal(!openSkillAddModal);
  };

  const getSkillData = () => {
    if (employeeId) {
      getSkillsUser(employeeId).then((res) => {
        setSkillsSet(res?.data);
      });
    }
  };

  useEffect(() => {
    getSkillData();
    getUserRoles();
  }, [employeeId]);

  useEffect(() => {
    if (isExpandAcknowledgement && !canEditAcknowledgement()) {
      dispatch(
        AppActions.toggleSnackBarOpen({
          message:
            'Document acknowledgements can only be edited by the employee themselves.',
          severity: 'info'
        })
      );
    }
  }, [isExpandAcknowledgement]);

  const deleteSkills = (data) => {
    deleteSkillsUser(data)
      .then(() => {
        setSnackBarMessage('Skill removed successfully.');
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        getSkillData();
        setOpenConfirmation(false);
      })
      .catch((e) => {
        setSnackBarMessage('Unable to remove skill.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      });
  };

  const [additionals, setAdditionals] = useState([]);

  const getAllManagers = async () => {
    const result = await getEmployeeManagers(employeeId);

    let filteredAdditionalsArray;
    let filteredMainsArray;
    if (result.data) {
      filteredAdditionalsArray = result?.data?.filter(
        (ele) => ele.level === 'additional'
      );
      filteredMainsArray = result?.data?.filter(
        (ele) => ele.level !== 'additional'
      );
    }
    if (filteredAdditionalsArray?.length > 0) {
      setAdditionals(
        filteredAdditionalsArray.map((add) => {
          return {
            EmployeeId: employeeId,
            ReporterId: add.employeeId,
            Level: 'additional',
            name: add.name
          };
        })
      );
    }

    let filteredTreeData;
    if (filteredMainsArray) {
      filteredTreeData = filteredMainsArray.map((manager) => {

        if (manager.level === 'primary') {
          setPrimaryManager({
            ReporterId: manager.employeeId,
            Level: manager.level
          });
          setPreviousPrimaryManager(manager.employeeId);
          return {
            title: manager.name,
            subtitle: 'Primary Reporting Manager'
          };
        }
        if (manager.level === 'secondary') {
          setSecondaryManager({
            ReporterId: manager.employeeId,
            Level: manager.level
          });
          return {
            title: manager.name,
            subtitle: 'Secondary Reporting Manager',
            children: filteredAdditionalsArray.map((additional) => {
              return {
                title: additional.name,
                subtitle: 'Additional Reporting Manager'
              };
            })
          };
        }
      });
    }

    setTreeData(
      filteredTreeData &&
        filteredTreeData.sort((x, y) =>
          x.subtitle === 'Primary Reporting Manager'
            ? -1
            : y.subtitle === 'Primary Reporting Manager'
            ? 1
            : 0
        )
    );
  };

  const getEmployeeImages = async () => {
    const result = await getEmployeeImagesById(employeeId);
    let images;
    if (result.data) {
      images = result.data.map((data) => {
        const image = `data:${data.type};base64,${data.base64Value}`;
        return {
          image: image,
          id: data.id
        };
      });

      setEmplyeeImages(images);
    }
  };

  const getEmployeeDocs = async () => {
    const result = await getEmployeeDocsById(employeeId);
    if (result.data) {
      setEmployeeAttachments(result.data);
    }
  };

  const deleteDocument = async (id: any) => {
    const result = await deleteEmployeeDocumentsById(id);
    if (result) {
      getEmployeeDocs();
    }
  };

  const getAllPageData = () => {
    dispatch(AppActions.showLoader());
    getEmplyeeDetails();
    getEmployeeImages();
    getEmployeeDocs();
    getAllManagers();
  };

  useEffect(() => {
    getAllPageData();
    getReportingManagers();
  }, []);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
    .MuiCardHeader-action{
      width: 100%
    }
  `
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [errors, setErrors] = useState<any>({});

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  useEffect(() => {
    if (tableId && Object.keys(errors).length === 0) {
      if (!isEmpty(image)) {
        uploadEmployeeImageById(tableId, image.file, getEmplyeeDetails);
      }
      if (attachment.file) {
        uploadEmployeeDocsById(tableId, attachment.file);
        setAttachment({});
      }
    }
  }, [tableId, errors]);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      //Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
      if (
        email.indexOf(
          '@digiratina.com',
          email.length - '@digiratina.com'.length
        ) !== -1
      ) {
        //VALID
        return true;
      } else {
        return false;
      }
    }
  };

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const checkArrayIncludes = (arr, obj) => {
    const errorData: any = {};
    errorData.bankNameError = 'Bank name required';
    setErrors(errorData);

    const titleValue = obj.title ? obj.title : obj;
    return arr.some((val) => val?.title === titleValue);
  };

  const onSubmit = (data: UpdateEmployee) => {
    // debugger;
    // if (!checkArrayIncludes(allBanks, bankValue)) {
    //   addBank({ bankName: bankValue?.title })
    //     .then(() => {
    //       validateFinalData(data);
    //     })
    //     .catch((e) => {
    //       dispatch(
    //         AppActions.toggleSnackBarOpen({
    //           message: e.response.data || 'Unable to add bank name',
    //           severity: 'error'
    //         })
    //       );
    //     });
    // } else {
    //   validateFinalData(data);
    // }
    validateFinalData(data);
  };

  const validateFinalData = (data: UpdateEmployee) => {
    const errorData: any = {};
    if (
      employeeInformation.name === '' ||
      employeeInformation.name?.trim()?.length < 1
    ) {
      errorData.nameError = 'Name required';
    }
    if (
      employeeInformation.employeeId === '' ||
      employeeInformation.employeeId?.trim()?.length < 1
    ) {
      errorData.employeeIdError = 'Employee Id required';
    }
    if (
      employeeInformation.nic === '' ||
      employeeInformation.nic?.trim()?.length < 1
    ) {
      errorData.nicError = 'NIC required';
    }
    if (employeeInformation?.nic?.length < 10) {
      errorData.nicError = 'NIC number cannot be less than 10';
    }
    if (employeeInformation.phoneNumber === '') {
      errorData.phoneNumberError = 'Phone Number required';
    }
    if (employeeInformation?.phoneNumber?.length < 10) {
      errorData.phoneNumberError = 'Phone number cannot be less than 10';
    }
    if (employeeInformation.emergencyPhoneNumber === '') {
      errorData.emergencyPhoneNumberError = 'Emergency Phone Number required';
    }
    if (employeeInformation?.emergencyPhoneNumber?.length < 10) {
      errorData.emergencyPhoneNumberError =
        'Emergency number cannot be less than 10';
    }
    if (
      employeeInformation.address === '' ||
      employeeInformation.address?.trim()?.length < 1
    ) {
      errorData.addressError = 'Address required';
    }
    if (
      employeeInformation.currentAddress === '' ||
      employeeInformation.currentAddress?.trim()?.length < 1
    ) {
      errorData.currentAddressError = 'Current Address required';
    }
    if (
      employeeInformation.email === '' ||
      employeeInformation.email?.trim()?.length < 1
    ) {
      errorData.emailError = 'email required';
    }
    if (!validateEmail(employeeInformation.email)) {
      errorData.emailError = 'Please enter valid email address';
    }
    if (employeeInformation.yearsOfExperience === '') {
      errorData.yearsOfExperienceError = 'Years of experience required';
    }
    if (employeeInformation.role === '') {
      errorData.roleError = 'User Role is required';
    }
    // if (employeeInformation.bankName === '') {
    //   errorData.bankNameError = 'Bank name required';
    // }
    // if (
    //   employeeInformation.branch === '' ||
    //   employeeInformation.branch?.trim()?.length < 1
    // ) {
    //   errorData.branchError = 'Branch required';
    // }
    // if (employeeInformation.branchCode === '') {
    //   errorData.branchCodeError = 'Branch code required';
    // }
    // if (
    //   employeeInformation.accountName === '' ||
    //   employeeInformation.accountName?.trim()?.length < 1
    // ) {
    //   errorData.accountNameError = 'Account name required';
    // }
    // if (employeeInformation.accountNumber === '') {
    //   errorData.accountNumberError = 'Account number required';
    // }
    if (!employeeTypeValue) {
      errorData.type = 'Employee Type is required.';
    }
    if (employeeTypeValue) {
      if (previousEmployeeType === 'Permanent') {
        if (
          employeeTypeValue === 'Probation' ||
          employeeTypeValue === 'Intern'
        ) {
          errorData.type = 'The employment type cannot change backwards.';
        }
      } else if (previousEmployeeType === 'Probation') {
        if (employeeTypeValue === 'Intern') {
          errorData.type = 'The employment type cannot change backwards.';
        }
      }

      if(previousEmployeeType === 'Intern') {
        if (employeeTypeValue === 'Probation' || employeeTypeValue === 'Permanent') {
          if (
            employeeInformation.updatedEmployeeNumber === '' ||
            employeeInformation.updatedEmployeeNumber?.trim()?.length < 1
          ) {
            errorData.employeeNumberError = 'Employee Id required';
          }
        }
      }
    }

    if(!reportingManager){
      errorData.reportingManagerError = "Reporting Manager is required."
      setReportingManagerError("Reporting Manager is required.");
    }

    //set employee gender id from string value
    setErrors(errorData);
    if (Object.keys(errorData).length === 0) {
      settableId(employeeId);
      let allData: any = employeeInformation;
      allData.employeeId = employeeInformation.employeeId;
      allData.employeeNumber = employeeInformation.updatedEmployeeNumber;
      allData.emergencyContactNumber = employeeInformation.emergencyPhoneNumber;
      allData.emergencyContactRelation =
        employeeInformation.emergencyContactRelationship;
      allData.password = randomPassword;
      allData.bankName = bankValue?.title;
      allData.joinedDate = moment(employeeInformation.joinedDate).format(
        'MM/DD/YYYY'
      );
      allData.carrierStartDate = employeeInformation?.carrierStartDate
        ? moment(employeeInformation?.carrierStartDate).format('YYYY-MM-DD')
        : null;
      allData.type = employeeTypeValue;
      allData.employeeTypeStartingDate = employeeTypeStartingDateValue
        ? moment(employeeTypeStartingDateValue).format('MM/DD/YYYY')
        : null;
      allData.employeeTypeEndingDate = employeeTypeEndingDateValue
        ? moment(employeeTypeEndingDateValue).format('MM/DD/YYYY')
        : null;

      delete allData.employeeFinance;
      delete allData.yearsOfExperience;

      delete allData.genderId;
      delete allData.maritalStatusId;

      allData.gender = genderValue;
      allData.maritalStatus = maritalStatusValue;

      if (!employeeTypeStartingDateValue) {
        setStartingDateError('From Date required');
      } else {
        if (previousPrimaryManager === primaryManager.ReporterId) {
          updateEmployeeData(allData);
        } else {
          updateReporter(employeeId, allData);
        }
      }
    }
  };

  const validateRoleAndEmployee = (empId, userId) => {
    if (empId !== userId) return false;

    return true;
  };

  const updateEmployeeData = (allData: any) => {
    dispatch(AppActions.showLoader());
    updateEmployeeInformation(allData)
      .then((res) => {
        const user = window.localStorage.getItem('user');
        const userModel = JSON.parse(user);

        if (
          !validateRoleAndEmployee(userModel?.EmployeeId, res?.data?.employeeId)
        ) {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Employee Updated Successfully',
              severity: 'success'
            })
          );
          getEmplyeeDetails();
          setEmplyeeImages(emplyeeImages.slice(0, -1));
          getEmployeeImages();
          getEmployeeDocs();
          getAllManagers();
          setIsChangeStartDate(false);
          setIsChangeEndDate(false);
          dispatch(AppActions.hideLoader());
          navigate('/employees');
        } else {
          dispatch(AppActions.hideLoader());
          setUnauthorized(true);
        }
      })
      .catch((err) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: err?.response?.data
              ? err.response.data
              : 'Unable to Edit the Employee',
            severity: 'error'
          })
        );
        setIsChangeStartDate(false);
        setIsChangeEndDate(false);
        dispatch(AppActions.hideLoader());
      });
  };

  const updateReporter = (tableId: string, allData: any) => {
    if (primaryManager || secondaryManager || additionals.length > 0) {
      let managers = [];
      if (primaryManager.ReporterId) {
        managers = [
          ...managers,
          {
            EmployeeId: tableId,
            PreviousReporterId: previousPrimaryManager,
            ...primaryManager
          }
        ];
      }
      if (secondaryManager.ReporterId) {
        managers = [
          ...managers,
          {
            EmployeeId: tableId,
            PreviousReporterId: previousPrimaryManager,
            ...secondaryManager
          }
        ];
      }
      if (additionals.length > 0) {
        const allAdditional = additionals.map((add) => {
          return {
            EmployeeId: tableId,
            Level: add.Level,
            ReporterId: add.ReporterId,
            PreviousReporterId: previousPrimaryManager
          };
        });

        managers = [...managers, ...allAdditional];
      }
      addManagers(managers)
        .then((res) => {
          updateEmployeeData(allData);
        })
        .catch((err) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: err?.response.data
                ? err?.response.data
                : 'Unable to Edit the Employee',
              severity: 'error'
            })
          );
        });
    }
  };

  const changeHandler = (event) => {
    const fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    const imageName = event.target.files[0].name;
    const extensionsRegex =
      /(\.pdf|\.xls|\.xlsx|\.doc|\.docx|\.png|\.jpeg|\.jpg)$/i;

    if (Number(fileSize) > 10) {
      setErrors((prev) => ({
        ...prev,
        attachmentError: 'Maximum file size exceeded.'
      }));
    } else if (!extensionsRegex.exec(imageName)) {
      setErrors((prev) => ({
        ...prev,
        attachmentError: 'File format is incorrect. Please check and try again.'
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        attachmentError: ''
      }));
      setAttachment({ file: event.target.files[0] });
    }
  };

  const attachmentsTypes = (attachment: any) => {
    const _extension =
      attachment.substring(
        attachment.lastIndexOf('.') + 1,
        attachment.length
      ) || attachment;
    let url = process.env.PUBLIC_URL;

    if (_extension === 'pdf') {
      url += '/img/pdficon.png';
    } else if (_extension === 'xlsx') {
      url += '/img/excelsheet.jpg';
    } else if (_extension === 'docx') {
      url += '/img/wordicon.png';
    }
    return url;
  };

  const [lastPromotedDate, setLastPromotedDate] = useState('');

  useEffect(() => {
    if (designation.length !== reversedDesignation.length) {
      const index = designation.findIndex((object) => {
        return object.endDate === null;
      });
      designation.unshift(designation.splice(index, 1)[0]);
      setLastPromotedDate(designation[0].startedDate);
      setreversedDesignation(designation);
    }
  }, [designation, reversedDesignation.length]);

  useEffect(() => {
    if (!employeeInformation.dob) {
      setEmployeeInformation({
        ...employeeInformation,
        dob: '2022-01-01'
      });
    }
  }, [employeeInformation]);

  const deleteAdditional = async (val: any) => {
    await deleteManagers(val);
    await getAllManagers();
  };

  const [permissions, setPermissions] = useState([]);
  const [fields, setFields] = useState([]);

  const getPermissions = (mail) => {
    getRoleEmployeePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      setPermissions(tabs[0].permissions);
      setFields(tabs[0].fields);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  const onlyAlphanumericRegex = /[^a-z0-9]/gi;

  const handleImageChange = (event) => {
    const fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    const imageName = event.target.files[0].name;
    const extensionsRegex = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;

    if (Number(fileSize) > 10) {
      setErrors((prev) => ({
        ...prev,
        imageError: 'Maximum file size exceeded.'
      }));
    } else if (!extensionsRegex.exec(imageName)) {
      setErrors((prev) => ({
        ...prev,
        imageError: 'File format is incorrect. Please check and try again.'
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        imageError: ''
      }));
      setImage({ file: event.target.files[0] });
    }
  };

  const [randomPassword, setRandomPassword] = useState('');

  const shuffle = (string) => {
    var array = string.split('');
    var tmp,
      current,
      top = array.length;

    if (top)
      while (--top) {
        current = Math.floor(Math.random() * (top + 1));
        tmp = array[current];
        array[current] = array[top];
        array[top] = tmp;
      }
    return array.join('');
  };

  const generatePassword = () => {
    const specials = '!@#$%&';
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';

    const all = specials + lowercase + uppercase + numbers;

    const pick = (exclusions?: any, string?: any, min?: any, max?: any) => {
      var n,
        chars = '';

      if (max === undefined) {
        n = min;
      } else {
        n = min + Math.floor(Math.random() * (max - min + 1));
      }

      var i = 0;
      while (i < n) {
        const character = string.charAt(
          Math.floor(Math.random() * string.length)
        );
        if (exclusions.indexOf(character) < 0 && chars.indexOf(character) < 0) {
          chars += character;
          i++;
        }
      }
      return chars;
    };

    let password = '';

    password += pick(password, specials, 1, 3);
    password += pick(password, lowercase, 1, 3);
    password += pick(password, uppercase, 1, 3);
    password += pick(password, all, 10);

    setRandomPassword(shuffle(password));

    setEmployeeInformation((prev) => ({
      ...prev,
      password: shuffle(password)
    }));
  };

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setSelectedOption(employeeInformation.designation);
  }, [employeeInformation]);

  const displayedOptions = useMemo(
    () =>
      billingRoles.length > 0 &&
      billingRoles?.filter((option) => containsText(option.name, searchText)),
    [searchText, billingRoles]
  );

  const displayedReportingManagers = useMemo(
    () =>
      employeeList.length > 0 &&
      employeeList?.filter((option) => containsText(option.name, searchText)),
    [searchText, employeeList]
  );

  const [bankValue, setBankValue] = useState<any>(null);
  const [allBanks, setAllBanks] = useState([]);
  const [allBanksArr, setAllBanksArr] = useState([]);

  const getAllBanksDetails = () => {
    getAllBanks().then((res) => {
      setAllBanksArr(res?.data);
      setAllBanks(
        res?.data.map((ele) => {
          return { title: ele.name };
        })
      );
    });
  };

  useEffect(() => {
    getAllBanksDetails();
  }, []);

  useEffect(() => {
    reportingManagerView();
  }, [employeeList]);

  const reportingManagerView = () => {
    employeeList.filter((item) => {
      if (item.employeeId === primaryManager.ReporterId) {
        setReportingManager(item.name);
      }
    });
  };

  useEffect(() => {
    reportingManagerView();
  }, [primaryManager])

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [deleteData, setDeleteData] = useState<any>({});

  const toggleConfirmation = (data) => {
    setDeleteData(data);
    setOpenConfirmation(!openConfirmation);
  };

  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);

    return date;
  };

  const CustomTableRow = withStyles({
    root: {
      height: '2.5rem',
      backgroundColor: '#E6E9FF !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: '0.4rem',
      cursor: 'pointer'
    }
  })(Card);
  const [isExpandGeneralDetails, setIsExpandGeneralDetails] =
    useState<boolean>(true);
  const [isExpandContactDetails, setIsExpandContactDetails] =
    useState<boolean>(false);
  const [isExpandEmploymentDetails, setIsExpandEmploymentDetails] =
    useState<boolean>(false);
  const [isExpandReportingManagers, setIsExpandReportingManagers] =
    useState<boolean>(false);
  const [isExpandEmploymentType, setIsExpandEmploymentType] =
    useState<boolean>(false);
  const [isExpandBankDetails, setIsExpandBankDetails] =
    useState<boolean>(false);
  const [isExpandUserAccountDetails, setIsExpandUserAccountDetails] =
    useState<boolean>(false);
  const [isExpandSkills, setIsExpandSkills] = useState<boolean>(false);
  const [isExpandFeedbacks, setIsExpandFeedbacks] = useState<boolean>(false);
  const [companyExperience, setCompanyExperience] = useState('');
  const [carrierStartDate, setCarrierStartDate] = useState('');
  const [carrierFullExperience, setCarrierFullExperience] = useState('');
  const [latestDesignation, setLatestDesignation] = useState('');

  const convertDuration = (duration) => {
    const parts = duration.split(' ');
    const yearsIndex = parts.findIndex(
      (part) => part === 'year' || part === 'years'
    );
    const monthsIndex = parts.findIndex(
      (part) => part === 'month' || part === 'months'
    );

    let years = 0;
    let months = 0;
    if (yearsIndex !== -1) {
      years = parseInt(parts[yearsIndex - 1]) || 0;
    }
    if (monthsIndex !== -1) {
      months = parseInt(parts[monthsIndex - 1]) || 0;
    }

    let convertedDuration = '';
    if (years > 0) {
      convertedDuration += years > 1 ? `${years} yrs ` : `${years} yr `;
    }
    if (months > 0) {
      convertedDuration += months > 1 ? `${months} mos` : `${months} mo`;
    }
    return convertedDuration.trim();
  };

  useEffect(() => {
    let endDate = moment().format('YYYY-MM-DD');
    let startDate = getCompanyStartDate(designation);
    setLatestDesignation(getLatestPosition(designation));
    const rangeExperience = calculateCompanyExperience(startDate, endDate);
    setCompanyExperience(rangeExperience);
  }, [designation]);

  useEffect(() => {
    let endDate = moment().format('YYYY-MM-DD');
    const rangeExperience = calculateCompanyExperience(
      carrierStartDate,
      endDate
    );
    setCarrierFullExperience(rangeExperience);
  }, [carrierStartDate]);

  const calculateCompanyExperience = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    const years = end.diff(start, 'years');
    start.add(years, 'years');
    const months = end.diff(start, 'months');

    let convertedDuration = '';
    if (years > 0) {
      convertedDuration += years > 1 ? `${years} yrs ` : `${years} yr `;
    }
    if (months > 0) {
      convertedDuration += months > 1 ? `${months} mos` : `${months} mo`;
    }
    return convertedDuration.trim();
  };

  const getCompanyStartDate = (employDesignation) => {
    let companyStartDate = null;

    employDesignation.forEach((record) => {
      const startDate = moment(record.startedDate, 'YYYY.MM.DD');
      if (!companyStartDate || startDate < companyStartDate) {
        companyStartDate = startDate;
      }
    });

    return companyStartDate?.format('YYYY-MM-DD');
  };

  const getLatestPosition = (employDesignation) => {
    let position = null;

    employDesignation.forEach((record) => {
      if (!record.endDate) {
        position = record.name;
      }
    });
    return position;
  };

  const formatDate = (dateString) => {
    return moment(dateString, 'YYYY.MM.DD').format('MMM YYYY');
  };

  const onSelect = (selectedList, selectedItem) => {
    setErrors((prev) => ({
      ...prev,
      nameError: ''
    }));

    const rolesArr = selectedList.map((e) => e.name);
    const roles = removeDuplicates(rolesArr);

    setValue('role', roles.join(','));
    setEmployeeInformation((prev) => ({
      ...prev,
      role: roles.join(',')
    }));
  };

  const onRemove = (selectedList, selectedItem) => {
    if (selectedItem.name === 'General User') {
      const generalUser = userRoles.find((e) => e.name === 'General User');
      if (generalUser && !selectedList.some((r) => r.name === 'General User')) {
        selectedList.unshift(generalUser);
      }
    }
    const rolesArr = selectedList.map((e) => e.name);
    const roles = removeDuplicates(rolesArr);

    setValue('role', roles.join(','));
    setEmployeeInformation((prev) => ({
      ...prev,
      role: roles.join(',')
    }));
  };

  const setSelectedRoles = () => {
    const roles = [];
    const generalUser = userRoles.find((e) => e.name === 'General User');

    if (employeeInformation?.role) {
      const user_roles = employeeInformation.role
        .split(',')
        .map((role) => role.trim())
        .filter(Boolean);

      user_roles.forEach((element) => {
        if (element === 'General User') return;
        const roleObj = userRoles.find((e) => e.name === element);
        if (roleObj) roles.push(roleObj);
      });
    }

    if (generalUser) {
      roles.unshift(generalUser);
    }
    return roles;
  };

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const parseSlaToMs = (sla?: string | number | null): number | null => {
    if (sla === null || sla === undefined) return null;

    if (typeof sla === 'number') {
      return Number.isFinite(sla) ? sla * 60 * 1000 : null;
    }

    const raw = String(sla).trim();
    if (!raw) return null;

    if (/^\d+$/.test(raw)) {
      return parseInt(raw, 10) * 60 * 1000;
    }

    const match = raw.match(/^(?:(\d+)d\s+)?(\d{1,2}):(\d{2})(?::(\d{2}))?$/i);
    if (!match) return null;

    const days = parseInt(match[1] || '0', 10);
    const hours = parseInt(match[2] || '0', 10);
    const minutes = parseInt(match[3] || '0', 10);
    const seconds = parseInt(match[4] || '0', 10);

    if ([days, hours, minutes, seconds].some((x) => Number.isNaN(x))) {
      return null;
    }

    const workingMsPerDay = 9 * 60 * 60 * 1000;
    return (
      days * workingMsPerDay +
      hours * 60 * 60 * 1000 +
      minutes * 60 * 1000 +
      seconds * 1000
    );
  };

  const formatWorkingMs = (workingMs: number): string => {
    const totalSeconds = Math.floor(workingMs / 1000);
    const workingSecondsPerDay = 9 * 60 * 60;
    const days = Math.floor(totalSeconds / workingSecondsPerDay);
    const remainingSeconds = totalSeconds % workingSecondsPerDay;

    const hrs = Math.floor(remainingSeconds / 3600);
    const mins = Math.floor((remainingSeconds % 3600) / 60);
    const secs = remainingSeconds % 60;

    return days > 0
      ? `${days}d ${String(hrs).padStart(2, '0')}:${String(mins).padStart(
          2,
          '0'
        )}:${String(secs).padStart(2, '0')}`
      : `${String(hrs).padStart(2, '0')}:${String(mins).padStart(
          2,
          '0'
        )}:${String(secs).padStart(2, '0')}`;
  };

  const getRemainingWorkingMs = (endDate: Date): number => {
    const WORK_START = 9;
    const WORK_END = 18;

    const toDateAtHour = (base: Date, hour: number) => {
      const d = new Date(base);
      const h = Math.floor(hour);
      const m = Math.round((hour - h) * 60);
      d.setHours(h, m, 0, 0);
      return d;
    };

    const getWorkingWindows = (date: Date): Array<[number, number]> => {
      if (date.getDay() === 0 || date.getDay() === 6) return [];
      return [[WORK_START, WORK_END]];
    };

    let now = new Date();
    let totalMs = 0;

    if (now > endDate) return 0;

    while (now < endDate) {
      const windows = getWorkingWindows(now);

      if (!windows.length) {
        now.setDate(now.getDate() + 1);
        now.setHours(WORK_START, 0, 0, 0);
        continue;
      }

      let advanced = false;

      for (const [windowStartHour, windowEndHour] of windows) {
        const windowStart = toDateAtHour(now, windowStartHour);
        const windowEnd = toDateAtHour(now, windowEndHour);

        if (endDate <= windowStart) {
          now = endDate;
          advanced = true;
          break;
        }

        if (now >= windowEnd) {
          continue;
        }

        const chunkStart = now > windowStart ? now : windowStart;
        const chunkEnd = endDate < windowEnd ? endDate : windowEnd;

        if (chunkStart < chunkEnd) {
          totalMs += chunkEnd.getTime() - chunkStart.getTime();
          now = chunkEnd;
          advanced = true;
        }

        if (now >= endDate) {
          break;
        }
      }

      if (now < endDate && !advanced) {
        now.setDate(now.getDate() + 1);
        now.setHours(WORK_START, 0, 0, 0);
      }
    }

    return totalMs;
  };

  useEffect(() => {
    timeLeftRef.current = timeLeft;
  }, [timeLeft]);

  useEffect(() => {
    const due = ackTask?.expectedCompletionAt;
    if (!due) return;
    const parsed = new Date(due);
    if (!isNaN(parsed.getTime())) {
      setLastKnownAckDueDate(due);
    }
  }, [ackTask, frozenAckTimerStorageKey]);

  useEffect(() => {
    if (!ackTask) {
      setTimeLeft('');
      return;
    }

    const updateCountdown = () => {
      const normalizedStatus = (ackTask?.status || '').toUpperCase();

      if (normalizedStatus === 'COMPLETED') {
        setTimeLeft('');
        return;
      }

      if (normalizedStatus === 'ON_HOLD') {
        const persistedFrozen = (() => {
          try {
            return localStorage.getItem(frozenAckTimerStorageKey) || '';
          } catch {
            return '';
          }
        })();
        if (persistedFrozen) {
          setTimeLeft(persistedFrozen);
          return;
        }

        const frozenMs = parseSlaToMs(ackTask?.sla);

        if (frozenMs !== null) {
          setTimeLeft(frozenMs <= 0 ? 'Overdue' : formatWorkingMs(frozenMs));
          return;
        }

        if (timeLeftRef.current) {
          setTimeLeft(timeLeftRef.current);
          return;
        }

        setTimeLeft('');
        return;
      }

      if (!ackTask?.expectedCompletionAt) {
        setTimeLeft('');
        return;
      }

      const end = new Date(ackTask.expectedCompletionAt);
      if (isNaN(end.getTime())) {
        setTimeLeft('');
        return;
      }

      const remaining = getRemainingWorkingMs(end);

      if (remaining <= 0) {
        setTimeLeft('Overdue');
        return;
      }

      setTimeLeft(formatWorkingMs(remaining));
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [ackTask, frozenAckTimerStorageKey]);

  return (
    <>
      <Container maxWidth="xl" className="employee-edit">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Grid container direction={'row'} sx={{ pb: 2, pt: 2 }}>
              <Grid item>
                <Typography
                  id="breadcrumb-employees"
                  onClick={() => {
                    navigate('/employees');
                  }}
                  style={{ cursor: 'pointer' }}
                  variant="h4"
                  component="h4"
                >
                  {' '}
                  Employee List/&nbsp;
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  style={{ fontWeight: 'normal' }}
                  variant="h4"
                  component="h4"
                >
                  {empName || '-'}
                </Typography>
              </Grid>
            </Grid>
            <Card>
              <Box>
                <Box
                  sx={{ width: '100%', boxShadow: 'inset 0 -1px 0 #eee' }}
                  px={2}
                >
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="wrapped label tabs example"
                  >
                    <Tab value={1} label="Information" />
                    <Tab value={2} label="Project Details" />
                    <Tab value={3} label="Leave History" />
                    <Tab value={4} label="Exam Results" />
                    <Tab value={5} label="Events" />
                  </Tabs>
                </Box>
                {tabValue === 1 && (
                  <Card sx={{ p: 2, height: '77vh', overflowY: 'scroll' }}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                          pl: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          height: 'fit-content',
                          borderRight: '1px solid rgba(34, 51, 84, 0.1)'
                        }}
                      >
                        <Grid item>
                          <Grid
                            item
                            sx={{ display: 'flex', pt: 1, pl: 1, mb: 2 }}
                          >
                            <img
                              alt="logo"
                              style={{
                                marginTop: -15,
                                objectFit: 'cover',
                                width: '72px',
                                height: '72px',
                                borderRadius: '50%'
                              }}
                              src={
                                emplyeeImages[0]?.image ||
                                process.env.PUBLIC_URL + '/img/user.png'
                              }
                            />
                            <Grid item sx={{ pl: 2 }}>
                              <Typography variant="h4">{empName}</Typography>
                              <Typography
                                variant="h5"
                                style={{ fontWeight: 'normal' }}
                              >
                                {employeeInformation.designation}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid
                            style={{
                              marginLeft: '9px',
                              marginBottom: '1.5rem',
                              marginTop: '0.5rem',
                              display: 'flex'
                            }}
                          >
                            <Grid>
                              <Grid
                                style={{ fontSize: '14px', fontWeight: 'bold' }}
                              >
                                Career Full Experience
                              </Grid>
                              <Grid style={{ fontSize: '13px' }}>
                                {carrierFullExperience
                                  ? carrierFullExperience
                                  : 'No experience'}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid style={{ marginLeft: '9px', display: 'flex' }}>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                '/img/digiratina-logo.png'
                              }
                              alt="digiratina-logo"
                              style={{ width: '3rem', height: '3rem' }}
                            />
                            <Grid style={{ marginLeft: '1rem' }}>
                              <Grid
                                style={{ fontSize: '14px', fontWeight: 'bold' }}
                              >
                                Digiratina
                              </Grid>
                              <Grid style={{ fontSize: '13px' }}>
                                {companyExperience
                                  ? companyExperience
                                  : 'No experience'}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Timeline
                            style={{ marginTop: '-4px', marginLeft: '15px' }}
                          >
                            {(sortEndDates || []).map((item, i) => {
                              return (
                                <>
                                  <TimelineItem>
                                    <TimelineSeparator>
                                      {item.endDate === null ? (
                                        <TimelineDot
                                          color="success"
                                          style={{ marginTop: '-14px' }}
                                        />
                                      ) : (
                                        <TimelineDot
                                          style={{ marginTop: '-14px' }}
                                        />
                                      )}
                                      <TimelineConnector
                                        sx={{
                                          marginTop: '20px',
                                          height: `${
                                            i === sortEndDates.length - 1
                                              ? '0%'
                                              : '100%'
                                          }`
                                        }}
                                      />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography
                                        sx={{
                                          fontSize: '13px',
                                          fontWeight: 'bold'
                                        }}
                                        variant="h5"
                                      >
                                        {item.name}
                                      </Typography>
                                      {item.endDate === null ? (
                                        <Typography
                                          fontWeight="light"
                                          display="block"
                                          sx={{ fontSize: '12px' }}
                                        >
                                          {formatDate(item.startedDate)} -
                                          Present{' '}
                                          {item.duration != '' && (
                                            <span>
                                              {' - ' +
                                                convertDuration(item.duration)}
                                            </span>
                                          )}
                                        </Typography>
                                      ) : (
                                        <Typography
                                          color="GrayText"
                                          fontWeight="light"
                                          display="block"
                                          sx={{ fontSize: '12px' }}
                                        >
                                          {formatDate(item.startedDate)} -{' '}
                                          {formatDate(item.endDate)}{' '}
                                          {item.duration != '' && (
                                            <span>
                                              {' - ' +
                                                convertDuration(item.duration)}
                                            </span>
                                          )}
                                        </Typography>
                                      )}
                                    </TimelineContent>
                                  </TimelineItem>
                                </>
                              );
                            })}
                          </Timeline>
                        </Grid>
                        <Divider />
                        <Typography
                          style={{ fontSize: '14px' }}
                          variant="h4"
                          sx={{ ml: 1, mt: 2, mb: 2 }}
                        >
                          Reporting Managers
                        </Typography>
                        {treeData?.length > 0 && (
                          <Grid container spacing={2} sx={{ marginBottom: 3 }}>
                            <SortableTree
                              treeData={treeData}
                              onChange={(treeData) => setTreeData(treeData)}
                              isVirtualized={false}
                              canDrag={false}
                              generateNodeProps={(row) => {
                                return {
                                  style: {
                                    borderLeft: `3px solid ${
                                      row.treeIndex === 0
                                        ? '#3CB371'
                                        : row.treeIndex === 1
                                        ? '#0000FF'
                                        : '#FFD700'
                                    }`
                                  },
                                  title: (
                                    <div
                                      style={{
                                        fontSize: '11px',
                                        fontWeight: 'normal'
                                      }}
                                    >
                                      {row.node.subtitle}
                                    </div>
                                  ),
                                  subtitle: (
                                    <div
                                      style={{
                                        lineHeight: '2em',
                                        fontSize: '13px',
                                        fontWeight: '700'
                                      }}
                                    >
                                      <Tooltip
                                        arrow
                                        title={row.node.title}
                                        placement="bottom-end"
                                      >
                                        <div>
                                          {changeStringLength(
                                            row.node.title,
                                            row.node.subtitle ===
                                              'Additional Reporting Manager'
                                              ? 25
                                              : 30
                                          )
                                            ? changeStringLength(
                                                row.node.title,
                                                row.node.subtitle ===
                                                  'Additional Reporting Manager'
                                                  ? 25
                                                  : 30
                                              )
                                            : row.node.title}
                                        </div>
                                      </Tooltip>
                                    </div>
                                  )
                                };
                              }}
                            />
                          </Grid>
                        )}
                        <Divider />
                        {visibility === 'false' && (
                          <Grid
                            item
                            style={{
                              paddingBottom: '100px',
                              marginTop: '1.5rem'
                            }}
                          >
                            <Button
                              id="btn-handleClickOpen"
                              disabled={
                                employeeInformation?.employeeFinance
                                  ?.isResign == true ||
                                permissions.some(
                                  (perm) =>
                                    perm.name === 'Promote User' && !perm.value
                                )
                              }
                              style={{ fontSize: '12px', fontWeight: 'normal' }}
                              sx={{ marginRight: 2 }}
                              variant="contained"
                              onClick={handleClickOpen}
                            >
                              Add Designation
                            </Button>
                            {open && (
                              <EmployeePromoteForm
                                employeeId={employeeId}
                                open={open}
                                onClose={handleClose}
                                getData={getEmplyeeDetails}
                                lastPromotedDate={lastPromotedDate}
                                latestPosition={latestDesignation}
                              />
                            )}
                            <Button
                              id="btn-toggleResignation"
                              disabled={
                                employeeInformation?.employeeFinance
                                  ?.isResign == true ||
                                permissions.some(
                                  (perm) =>
                                    perm.name === 'Resign User' && !perm.value
                                )
                              }
                              variant="contained"
                              style={{
                                backgroundColor: 'rgba(231, 210, 211, 0.3)',
                                color: '#ED1C24',
                                fontSize: '12px',
                                fontWeight: 'normal',
                                width: '8rem'
                              }}
                              onClick={() => toggleResignation()}
                            >
                              Resignation
                            </Button>
                            <EmployeeResignation
                              open={openResignation}
                              toggle={toggleResignation}
                              employeeId={employeeId}
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={8}
                        style={{
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          paddingBottom: '80px',
                          paddingLeft: '2rem'
                        }}
                      >
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandGeneralDetails(!isExpandGeneralDetails)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandGeneralDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'1'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'General Details'}
                              </Typography>
                            </div>
                            {isExpandGeneralDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandGeneralDetails ? (
                            <Grid style={{ marginBottom: '1rem' }}>
                              <Grid container spacing={2} sx={{ p: 1 }}>
                                <Grid item xs={6}>
                                  <FormControl fullWidth>
                                    <Typography
                                      style={{ fontSize: '13px' }}
                                      color="GrayText"
                                    >
                                      Employee Name
                                    </Typography>
                                    <TextField
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Name in Jira' &&
                                            !field.edit
                                        )
                                      }
                                      size="small"
                                      id="name"
                                      {...register('name')}
                                      placeholder="Employee Name"
                                      variant="outlined"
                                      value={employeeInformation.name}
                                      onChange={(e) => {
                                        if (e.target.value.length < 51) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            nameError: ''
                                          }));
                                          setEmployeeInformation((prev) => ({
                                            ...prev,
                                            name: e.target.value
                                          }));
                                        }
                                      }}
                                    />
                                    {errors?.nameError && (
                                      <Typography
                                        style={{
                                          paddingRight: 15,
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {errors?.nameError}
                                      </Typography>
                                    )}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    NIC
                                  </Typography>
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'NIC' && !field.edit
                                      )
                                    }
                                    {...register('nic')}
                                    id="nic"
                                    size="small"
                                    fullWidth
                                    placeholder="Employee Name"
                                    variant="outlined"
                                    value={employeeInformation.nic}
                                    onChange={(e) => {
                                      e.target.value = e.target.value.replace(
                                        onlyAlphanumericRegex,
                                        ''
                                      );
                                      if (e.target.value.length < 13) {
                                        setErrors((prev) => ({
                                          ...prev,
                                          nicError: ''
                                        }));
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          nic: e.target.value
                                        }));
                                      }
                                    }}
                                  />
                                  {errors?.nicError && (
                                    <Typography
                                      style={{
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.nicError}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    Gender
                                  </Typography>
                                  {!isEdit ? (
                                    <TextField
                                      id="gender-view"
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Gender' &&
                                            !field.edit
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      variant="outlined"
                                      value={genderValue}
                                    />
                                  ) : (
                                    <Select
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Gender' &&
                                            !field.edit
                                        )
                                      }
                                      className="text-primary"
                                      {...register('genderId')}
                                      id="genderId"
                                      size="small"
                                      fullWidth
                                      displayEmpty
                                      value={genderValue}
                                      onChange={(e) => {
                                        setGenderValue(e.target.value);
                                      }}
                                    >
                                      {genders.map((gnd) => (
                                        <MenuItem
                                          key={gnd.id}
                                          value={gnd.title}
                                        >
                                          {gnd.title}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    style={{ fontSize: '13px' }}
                                    color="GrayText"
                                  >
                                    Marital Status
                                  </Typography>
                                  {!isEdit ? (
                                    <TextField
                                      id="maritalStatusValue-view"
                                      inputProps={{
                                        style: { fontSize: '13px' }
                                      }}
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Marital Status' &&
                                            !field.edit
                                        )
                                      }
                                      size="small"
                                      fullWidth
                                      variant="outlined"
                                      value={maritalStatusValue}
                                    />
                                  ) : (
                                    <Select
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Martial Status' &&
                                            !field.edit
                                        )
                                      }
                                      {...register('maritalStatusId')}
                                      id="maritalStatusId"
                                      fullWidth
                                      size="small"
                                      label="Marital Status"
                                      displayEmpty
                                      value={maritalStatusValue}
                                      onChange={(e) => {
                                        setMaritalStatusValue(e.target.value);
                                      }}
                                    >
                                      {maritalStatus.map((ms) => (
                                        <MenuItem key={ms.id} value={ms.title}>
                                          {ms.title}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography
                                    color="GrayText"
                                    style={{ fontSize: '13px' }}
                                  >
                                    Date of Birth
                                  </Typography>
                                  <FormControl fullWidth>
                                    <DatePicker
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name === 'Date Of Birth' &&
                                            !field.edit
                                        )
                                      }
                                      InputProps={{
                                        className: 'date-picker'
                                      }}
                                      maxDate={subtractYears(new Date(), 16)}
                                      renderInput={(params) => (
                                        <TextField {...params} id="dob" />
                                      )}
                                      value={
                                        employeeInformation?.dob
                                          ? employeeInformation.dob
                                          : ''
                                      }
                                      onChange={(newValue) => {
                                        if (newValue) {
                                          setEmployeeInformation((prev) => ({
                                            ...prev,
                                            dob: moment(newValue).format(
                                              'YYYY-MM-DD'
                                            )
                                          }));
                                        }
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                {isEdit && (
                                  <>
                                    <Grid item xs={4}>
                                      <Typography
                                        color="GrayText"
                                        style={{ fontSize: '13px' }}
                                      >
                                        Add Attachment
                                      </Typography>
                                      <TextField
                                        id="attachmentName"
                                        inputProps={{
                                          style: { fontSize: '13px' }
                                        }}
                                        fullWidth
                                        size="small"
                                        placeholder="No file Selected"
                                        value={
                                          Object.keys(attachment).length === 0
                                            ? ''
                                            : attachment?.file?.name
                                        }
                                      />
                                      <p
                                        style={{
                                          marginLeft: 5,
                                          marginTop: 0,
                                          marginBottom: 0,
                                          fontSize: '0.6rem'
                                        }}
                                      >
                                        Maximum file upload size: 10MB
                                      </p>
                                      {errors?.attachmentError && (
                                        <Typography
                                          style={{
                                            paddingLeft: 15,
                                            paddingRight: 15,
                                            fontSize: '11px'
                                          }}
                                          color="red"
                                        >
                                          {errors?.attachmentError}
                                        </Typography>
                                      )}
                                    </Grid>
                                    <Grid item xs={2}>
                                      <Button
                                        id="btn-changeHandler"
                                        sx={{
                                          marginRight: 2,
                                          mt: '1.25rem',
                                          border: '1px solid'
                                        }}
                                      >
                                        Choose
                                        <input
                                          type="file"
                                          name="attachment"
                                          id="upload-attachment"
                                          accept=".pdf, .xls, .xlsx, .doc, .docx, .png, .jpeg, .jpg"
                                          onChange={changeHandler}
                                        />
                                      </Button>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                              {employeeAttachments.length > 0 && (
                                <Fragment>
                                  <Typography
                                    style={{ fontSize: '14px' }}
                                    variant="h4"
                                    sx={{ ml: 1, mt: 2, mb: 2 }}
                                  >
                                    Attachments
                                  </Typography>
                                  <Grid container spacing={2} sx={{ p: 1 }}>
                                    {employeeAttachments.map(
                                      (attachment, index) => {
                                        return (
                                          <Grid
                                            key={index}
                                            item
                                            xs={6}
                                            display="flex"
                                            alignItems="center"
                                          >
                                            <img
                                              src={attachmentsTypes(
                                                attachment.name
                                              )}
                                              style={{
                                                width: '32px',
                                                height: '32px'
                                              }}
                                              alt=""
                                            />
                                            <span
                                              id="btn-attachment-download"
                                              onClick={async () => {
                                                const response = await fetch(
                                                  process.env
                                                    .REACT_APP_EMPLOYEE_MANAGEMENT_ENDPOINT +
                                                    'attachment/document?documentId=' +
                                                    attachment.id
                                                );
                                                const blob =
                                                  await response.blob();
                                                const url =
                                                  window.URL.createObjectURL(
                                                    blob
                                                  );
                                                const link =
                                                  document.createElement('a');
                                                link.href = url;
                                                link.setAttribute(
                                                  'download',
                                                  attachment.name
                                                );
                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();
                                                window.URL.revokeObjectURL(url);
                                              }}
                                              style={{
                                                fontSize: '12px',
                                                cursor: 'pointer'
                                              }}
                                            >{`${attachment.name} - `}</span>
                                            &nbsp;
                                            <span
                                              style={{
                                                color: '#d3d3d3',
                                                fontSize: '12px'
                                              }}
                                            >
                                              {`${Math.round(
                                                attachment.size /
                                                  Math.pow(1024, 1)
                                              )} kb`}
                                            </span>
                                            {isEdit ||
                                              (employeeInformation
                                                ?.employeeFinance?.isResign ==
                                                true && (
                                                <CancelIcon
                                                  id="btn-deleteDocument"
                                                  sx={{
                                                    marginLeft: 1,
                                                    fontSize: '14px',
                                                    color: 'GrayText',
                                                    cursor: 'pointer',
                                                    marginBottom: '-0.15rem'
                                                  }}
                                                  fontSize={'inherit'}
                                                  onClick={() =>
                                                    deleteDocument(
                                                      attachment.id
                                                    )
                                                  }
                                                />
                                              ))}
                                          </Grid>
                                        );
                                      }
                                    )}
                                  </Grid>
                                </Fragment>
                              )}

                              <Fragment>
                                <Grid container spacing={2} sx={{ p: 1 }}>
                                  <Grid item xs={8}>
                                    <Typography
                                      style={{
                                        marginTop: '0.5rem',
                                        fontSize: '13px',
                                        fontFamily:
                                          'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                                      }}
                                      fontWeight="light"
                                      variant="h5"
                                    >
                                      Profile Photo
                                    </Typography>
                                    <TextField
                                      id="image"
                                      disabled={!isEdit}
                                      InputProps={{
                                        style: {
                                          fontSize: '12px',
                                          height: '2.25rem'
                                        }
                                      }}
                                      fullWidth
                                      size="small"
                                      placeholder="No image Selected"
                                      value={
                                        Object.keys(image).length === 0
                                          ? ''
                                          : image?.file?.name
                                      }
                                    />
                                    <p
                                      style={{
                                        marginLeft: '1rem',
                                        marginTop: 0,
                                        marginBottom: 0,
                                        fontSize: '0.6rem',
                                        height: '0rem'
                                      }}
                                    >
                                      Maximum file upload size: 10MB
                                    </p>
                                    {errors?.imageError && (
                                      <Typography
                                        style={{
                                          paddingRight: 15,
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {errors?.imageError}
                                      </Typography>
                                    )}
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Button
                                      id="btn-handleImageChange"
                                      disabled={!isEdit}
                                      style={{
                                        marginTop: '1.6rem',
                                        border: '1px solid #5569ff',
                                        marginLeft: '-0.5rem',
                                        color: '#5569ff',
                                        padding: '6px 8px',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        fontWeight: 'normal'
                                      }}
                                    >
                                      Choose
                                      <input
                                        type="file"
                                        name="attachment"
                                        id="upload-profile"
                                        accept="image/png, image/gif, image/jpeg"
                                        onChange={handleImageChange}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Fragment>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandContactDetails(!isExpandContactDetails)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandContactDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'2'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Contact Details'}
                              </Typography>
                            </div>
                            {isExpandContactDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandContactDetails ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, mb: '1rem' }}
                            >
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Phone
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='phoneNumber'/> */}
                                  <MuiPhoneNumber
                                    defaultCountry={'lk'}
                                    size="small"
                                    id="phoneNumber"
                                    {...register('phoneNumber')}
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'Phone Number' &&
                                          !field.edit
                                      )
                                    }
                                    fullWidth
                                    type="text"
                                    placeholder="Phone"
                                    variant="outlined"
                                    value={employeeInformation.phoneNumber}
                                    onChange={(e) => {
                                      if (e.length < 16) {
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          phoneNumber: e
                                        }));
                                        setErrors((prev) => ({
                                          ...prev,
                                          phoneNumberError: ''
                                        }));
                                      }
                                    }}
                                  />
                                </FormControl>
                                {errors?.phoneNumberError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.phoneNumberError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Emergency Phone
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='emergencyPhoneNumber'/> */}
                                  <MuiPhoneNumber
                                    defaultCountry={'lk'}
                                    size="small"
                                    id="emergencyPhoneNumber"
                                    {...register('emergencyPhoneNumber')}
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name ===
                                            'Emergency Phone Number' &&
                                          !field.edit
                                      )
                                    }
                                    fullWidth
                                    type="text"
                                    placeholder="Emergency Phone"
                                    variant="outlined"
                                    value={
                                      employeeInformation.emergencyPhoneNumber
                                    }
                                    onChange={(e) => {
                                      if (e.length < 16) {
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          emergencyPhoneNumber: e
                                        }));
                                        setErrors((prev) => ({
                                          ...prev,
                                          emergencyPhoneNumberError: ''
                                        }));
                                      }
                                    }}
                                  />
                                </FormControl>
                                {errors?.emergencyPhoneNumberError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emergencyPhoneNumberError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Permanent Address
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='address'/> */}
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'Address' &&
                                          !field.edit
                                      )
                                    }
                                    {...register('address')}
                                    id="address"
                                    size="small"
                                    multiline
                                    fullWidth
                                    placeholder="Address"
                                    variant="outlined"
                                    value={employeeInformation.address}
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        address: e.target.value
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        addressError: ''
                                      }));
                                    }}
                                  />
                                </FormControl>
                                {errors?.addressError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.addressError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Current Address
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='currentAddress'/> */}
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'Current Address' &&
                                          !field.edit
                                      )
                                    }
                                    {...register('currentAddress')}
                                    id="currentAddress"
                                    size="small"
                                    fullWidth
                                    multiline
                                    placeholder="Current Address"
                                    variant="outlined"
                                    value={employeeInformation.currentAddress}
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        currentAddress: e.target.value
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        currentAddressError: ''
                                      }));
                                    }}
                                  />
                                </FormControl>
                                {errors?.currentAddressError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.currentAddressError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Skype ID
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='skypeID'/> */}
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'Skype Id' &&
                                          !field.edit
                                      )
                                    }
                                    {...register('skypeID')}
                                    id="skypeID"
                                    size="small"
                                    fullWidth
                                    placeholder="Skype ID"
                                    variant="outlined"
                                    value={employeeInformation.skypeID}
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        skypeID: e.target.value?.trim()
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        skypeIDError: ''
                                      }));
                                    }}
                                  />
                                </FormControl>
                                {errors?.skypeIDError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.skypeIDError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Official Email Address
                                </Typography>
                                <TextField
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  disabled
                                  {...register('email')}
                                  id="email"
                                  size="small"
                                  fullWidth
                                  placeholder="Email Address"
                                  variant="outlined"
                                  value={employeeInformation.email}
                                  onChange={(e) => {
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      email: e.target.value
                                    }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      emailError: ''
                                    }));
                                  }}
                                />
                                {errors?.emailError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emailError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Emergency Contact Person
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='emergencyContactName'/> */}
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name ===
                                            'emergencyContactName' &&
                                          !field.edit
                                      )
                                    }
                                    {...register('emergencyContactName')}
                                    id="emergencyContactName"
                                    size="small"
                                    fullWidth
                                    multiline
                                    placeholder="Emergency Contact Person"
                                    variant="outlined"
                                    value={
                                      employeeInformation.emergencyContactName
                                    }
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        emergencyContactName: e.target.value
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        emergencyContactNameError: ''
                                      }));
                                    }}
                                  />
                                </FormControl>
                                {errors?.emergencyContactNameError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emergencyContactNameError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Emergency Contact Relationship
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <input type="text" disabled className="inputStyle"  placeholder='---' id='emergencyContactRelationship'/> */}
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled={
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name ===
                                            'emergencyContactRelationship' &&
                                          !field.edit
                                      )
                                    }
                                    {...register(
                                      'emergencyContactRelationship'
                                    )}
                                    id="emergencyContactRelationship"
                                    size="small"
                                    fullWidth
                                    placeholder="Emergency Contact Relationship"
                                    variant="outlined"
                                    value={
                                      employeeInformation.emergencyContactRelationship
                                    }
                                    onChange={(e) => {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        emergencyContactRelationship:
                                          e.target.value
                                      }));
                                      setErrors((prev) => ({
                                        ...prev,
                                        emergencyContactRelationError: ''
                                      }));
                                    }}
                                  />
                                </FormControl>
                                {errors?.emergencyContactRelationError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.emergencyContactRelationError}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandEmploymentDetails(
                                !isExpandEmploymentDetails
                              )
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandEmploymentDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'3'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Employment Details'}
                              </Typography>
                            </div>
                            {isExpandEmploymentDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandEmploymentDetails ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, mb: '1rem' }}
                            >
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Employee ID
                                </Typography>
                                <TextField
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  disabled
                                  {...register('employeeId')}
                                  id="employeeId"
                                  size="small"
                                  fullWidth
                                  placeholder="Employee ID"
                                  variant="outlined"
                                  value={employeeInformation.employeeNumber}
                                  onChange={(e) => {
                                    if (e.target.value.length < 11) {
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        employeeId: e.target.value
                                      }));
                                    }

                                    setErrors((prev) => ({
                                      ...prev,
                                      employeeIdError: ''
                                    }));
                                  }}
                                />
                                {errors?.employeeIdError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.employeeIdError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Tier
                                </Typography>
                                <TextField
                                  id="tier"
                                  inputProps={{ style: { fontSize: '13px' } }}
                                  disabled
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  value={employeeInformation.tier}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Joined Date
                                </Typography>
                                <FormControl fullWidth>
                                  <DatePicker
                                    // disabled={!isEdit}
                                    disabled
                                    InputProps={{
                                      className: 'date-picker'
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} id="joinedDate" />
                                    )}
                                    value={
                                      employeeInformation?.joinedDate
                                        ? employeeInformation.joinedDate
                                        : ''
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          joinedDate:
                                            moment(newValue).format(
                                              'YYYY-MM-DD'
                                            )
                                        }));
                                      }
                                    }}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Career Start Date
                                </Typography>
                                <FormControl fullWidth>
                                  <DatePicker
                                    disabled={!isEdit}
                                    InputProps={{
                                      className: 'date-picker'
                                    }}
                                    maxDate={
                                      new Date(employeeInformation?.joinedDate)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        id="carrierStartDate"
                                      />
                                    )}
                                    value={
                                      employeeInformation?.carrierStartDate
                                        ? employeeInformation.carrierStartDate
                                        : ''
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          carrierStartDate:
                                            moment(newValue).format(
                                              'YYYY-MM-DD'
                                            )
                                        }));
                                      }
                                    }}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandReportingManagers(
                                !isExpandReportingManagers
                              )
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandReportingManagers
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'4'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Reporting Managers'}
                              </Typography>
                            </div>
                            {isExpandReportingManagers ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandReportingManagers ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, mb: '1rem' }}
                            >
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Primary Reporting Manager
                                </Typography>
                                {isEdit ? (
                                  <>
                                    <Select
                                      MenuProps={{ autoFocus: false }}
                                      disabled={
                                        !isEdit ||
                                        fields.some(
                                          (field) =>
                                            field.name ===
                                              'Reporting Managers' &&
                                            !field.edit
                                        )
                                      }
                                      {...register('primaryManager')}
                                      id="primaryManager"
                                      className="text-primary"
                                      size="small"
                                      placeholder="Select Primary Reporting Manager"
                                      fullWidth
                                      displayEmpty
                                      defaultValue={
                                        primaryManager.ReporterId || ''
                                      }
                                      value={primaryManager.ReporterId || ''}
                                      onChange={(e) => {
                                        setPrimaryManager({
                                          ReporterId: e.target.value,
                                          Level: 'primary'
                                        });
                                        employeeList.filter((item) => {
                                          if (item.employeeId === e.target.value) {
                                            setReportingManager(item.name);
                                          }
                                        });

                                        setReportingManagerError('');
                                      }}
                                      onClose={() => setSearchText('')}
                                    >
                                      <ListSubheader>
                                        <TextField
                                          id="searchPrimaryManager"
                                          size="small"
                                          autoFocus
                                          placeholder="Type to search..."
                                          fullWidth
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <SearchIcon />
                                              </InputAdornment>
                                            )
                                          }}
                                          onChange={(e) =>
                                            setSearchText(e.target.value)
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key !== 'Escape') {
                                              e.stopPropagation();
                                            }
                                          }}
                                        ></TextField>
                                      </ListSubheader>
                                      {displayedReportingManagers.length > 0 &&
                                        displayedReportingManagers?.map(
                                          (option, i) => (
                                            <MenuItem
                                              key={option.employeeId}
                                              value={option.employeeId}
                                            >
                                              {option.name}
                                            </MenuItem>
                                          )
                                        )}
                                    </Select>
                                    {reportingManagerError && (
                                      <Typography
                                        style={{
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {reportingManagerError}
                                      </Typography>
                                    )}
                                  </>
                                ) : (
                                  <TextField
                                    id="primaryManager-view"
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled
                                    size="small"
                                    fullWidth
                                    placeholder=""
                                    variant="outlined"
                                    value={reportingManager}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandEmploymentType(!isExpandEmploymentType)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandEmploymentType
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'5'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Employment Type'}
                              </Typography>
                            </div>
                            {isExpandEmploymentType ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandEmploymentType ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, mb: '1rem' }}
                            >
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Type
                                  <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                {isEdit ? (
                                  <>
                                    <Select
                                      {...register('type')}
                                      id="type"
                                      fullWidth
                                      size="small"
                                      label="type"
                                      displayEmpty
                                      value={employeeTypeValue}
                                      onChange={(e) => {
                                        setEmployeeTypeValue(e.target.value);

                                        if (e.target.value) {
                                          if (
                                            previousEmployeeType === 'Permanent'
                                          ) {
                                            if (
                                              e.target.value === 'Probation' ||
                                              e.target.value === 'Intern'
                                            ) {
                                              setEmployeeTypeError(
                                                'The employment type cannot change backwards.'
                                              );
                                            } else {
                                              setEmployeeTypeError('');
                                            }
                                          } else if (
                                            previousEmployeeType === 'Probation'
                                          ) {
                                            if (e.target.value === 'Intern') {
                                              setEmployeeTypeError(
                                                'The employment type cannot change backwards.'
                                              );
                                            } else {
                                              setEmployeeTypeError('');
                                            }
                                          }

                                          if (
                                            previousEmployeeType === 'Intern'
                                          ) {
                                            if (
                                              e.target.value === 'Probation' ||
                                              e.target.value === 'Permanent'
                                            ) {
                                              setShowEmployeeNumber(true);
                                              setEmployeeInformation((prev) => ({
                                                ...prev,
                                                updatedEmployeeNumber: "",
                                                employeeNumber: employeeInformation.employeeId
                                              }));
                                            } else {
                                              setEmployeeInformation((prev) => ({
                                                ...prev,
                                                updatedEmployeeNumber: employeeInformation.employeeId,
                                                employeeNumber: employeeInformation.employeeId
                                              }));
                                              setShowEmployeeNumber(false);
                                            }
                                          }
                                        } else {
                                          setEmployeeTypeError(
                                            'Employee Type is required.'
                                          );
                                        }
                                      }}
                                    >
                                      {employeeType.map((e) => (
                                        <MenuItem key={e.value} value={e.value}>
                                          {e.value}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {employeeTypeError && (
                                      <Typography
                                        style={{
                                          fontSize: '11px'
                                        }}
                                        color="red"
                                      >
                                        {employeeTypeError}
                                      </Typography>
                                    )}
                                  </>
                                ) : (
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    disabled
                                    id="type-view"
                                    {...register('type')}
                                    size="small"
                                    fullWidth
                                    placeholder="Select Type"
                                    variant="outlined"
                                    value={employeeTypeValue}
                                    onChange={(e) => {}}
                                  />
                                )}
                              </Grid>
                              {showEmployeeNumber &&
                                <Grid item xs={6}>
                                  <Typography
                                    color="GrayText"
                                    style={{ fontSize: '13px' }}
                                  >
                                    Employee ID
                                    <span style={{ color: 'red' }}>*</span>
                                  </Typography>
                                  <TextField
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    {...register('employeeNumber')}
                                    id="employeeNumber"
                                    size="small"
                                    fullWidth
                                    placeholder="Employee ID"
                                    variant="outlined"
                                    value={employeeInformation.updatedEmployeeNumber}
                                    onChange={(e) => {
                                      if (e.target.value.length < 11) {
                                        setEmployeeInformation((prev) => ({
                                          ...prev,
                                          updatedEmployeeNumber: e.target.value
                                        }));
                                      }

                                      setErrors((prev) => ({
                                        ...prev,
                                        employeeNumberError: ''
                                      }));
                                    }}
                                  />
                                  {errors?.employeeNumberError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.employeeNumberError}
                                    </Typography>
                                  )}
                                </Grid>
                              }
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  From
                                  <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                <FormControl fullWidth>
                                  <DatePicker
                                    disabled={!isEdit}
                                    InputProps={{
                                      className: 'date-picker'
                                    }}
                                    minDate={
                                      new Date(employeeInformation?.joinedDate)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        id="employeeTypeStartingDate"
                                      />
                                    )}
                                    value={
                                      isChangeStartDate
                                        ? employeeTypeStartingDateValue
                                        : startingDateValue
                                        ? startingDateValue
                                        : ''
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        setEmployeeTypeStartingDateValue(
                                          moment(newValue).format('YYYY-MM-DD')
                                        );
                                        setErrors((prev) => ({
                                          ...prev,
                                          employeeTypeStartingDate: ''
                                        }));
                                        setStartingDateError('');
                                        setIsChangeStartDate(true);
                                      }
                                    }}
                                  />
                                </FormControl>
                                {startingDateError && (
                                  <Typography
                                    style={{
                                      paddingLeft: 15,
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {startingDateError}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  To
                                </Typography>
                                <FormControl fullWidth>
                                  <DatePicker
                                    disabled={!isEdit}
                                    InputProps={{
                                      className: 'date-picker'
                                    }}
                                    minDate={
                                      new Date(employeeTypeStartingDateValue)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        id="employeeTypeEndingDate"
                                      />
                                    )}
                                    value={
                                      isChangeEndDate
                                        ? employeeTypeEndingDateValue
                                        : endingDateValue
                                        ? endingDateValue
                                        : ''
                                    }
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        setEmployeeTypeEndingDateValue(
                                          moment(newValue).format('YYYY-MM-DD')
                                        );
                                        setErrors((prev) => ({
                                          ...prev,
                                          employeeTypeEndingDate: ''
                                        }));
                                        setIsChangeEndDate(true);
                                      }
                                    }}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandBankDetails(!isExpandBankDetails)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandBankDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'6'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Bank Details'}
                              </Typography>
                            </div>
                            {isExpandBankDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandBankDetails ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, mb: '1rem' }}
                            >
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Bank Name
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <Autocomplete
                                  disabled={
                                    !isEdit ||
                                    fields.some(
                                      (field) => field.name === 'Bank' && !field.edit
                                    )
                                  }
                                  fullWidth
                                  // style={TextFieldStyle}
                                  value={bankValue}
                                  {...register('bankName', {})}
                                  id="bankName"
                                  onChange={(event, newValue) => {
                                    if (typeof newValue === 'string') {
                                      setBankValue({
                                        title: newValue
                                      });
                                    } else if (newValue && newValue.inputValue) {
                                      // Create a new value from the user input
                                      setBankValue({
                                        title: newValue.inputValue
                                      });
                                    } else {
                                      setBankValue(newValue);
                                    }
                                    setErrors((prev) => ({
                                      ...prev,
                                      bankNameError: ''
                                    }));
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      bankName: newValue
                                    }));
                                  }}
                                  filterOptions={(options, params) => {
                                    const filtered = filter(options, params);
        
                                    const { inputValue } = params;
                                    // Suggest the creation of a new value
                                    const isExisting = options.some(
                                      (option) => inputValue === option.title
                                    );
                                    if (
                                      inputValue !== '' &&
                                      !isExisting &&
                                      inputValue?.trim().length > 0
                                    ) {
                                      filtered.push({
                                        inputValue,
                                        title: `Add "${inputValue}"`
                                      });
                                    }
                                    return filtered;
                                  }}
                                  selectOnFocus
                                  clearOnBlur
                                  handleHomeEndKeys
                                  options={allBanks}
                                  getOptionLabel={(option) => {
                                    // Value selected with enter, right from the input
                                    if (typeof option === 'string') {
                                      return option;
                                    }
                                    // Add "xxx" option created dynamically
                                    if (option.inputValue) {
                                      return option.inputValue;
                                    }
                                    // Regular option
                                    return option.title;
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props}>{option.title}</li>
                                  )}
                                  freeSolo
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      // value={bankValue}
                                      // {...register('bankName', {})}
                                      placeholder="Bank Name"
                                    />
                                  )}
                                  size="small"
                                /> */}
                                  <input
                                    type="text"
                                    disabled
                                    className="inputStyle"
                                    placeholder="---"
                                    id="bankName"
                                  />
                                  {errors?.bankNameError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.bankNameError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Branch Code
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <TextField
                                  disabled
                                  {...register('branchCode', {})}
                                  InputProps={{
                                    style: { fontSize: '12px', height: '2.25rem' }
                                  }}
                                  id="branchCode"
                                  size="small"
                                  fullWidth
                                  type="number"
                                  placeholder="---"
                                  variant="outlined"
                                  // value={Number(employeeInformation?.branchCode) || ''}
                                  onChange={(e) => {
                                    if (e.target.value.length < 11) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        branchCodeError: ''
                                      }));
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        branchCode: e.target.value
                                      }));
                                    }
                                  }}
                                /> */}
                                  <input
                                    type="text"
                                    disabled
                                    className="inputStyle"
                                    placeholder="---"
                                    id="branchCode"
                                  />
                                  {errors?.branchCodeError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.branchCodeError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Branch
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <TextField
                                  disabled
                                  size="small"
                                  {...register('branch', {})}
                                  InputProps={{
                                    style: { fontSize: '12px', height: '2.25rem' }
                                  }}
                                  id="branch"
                                  // style={TextFieldStyle}
                                  fullWidth
                                  placeholder="---"
                                  variant="outlined"
                                  // value={employeeInformation?.branch}
                                  onChange={(e) => {
                                    if (e.target.value.length < 51) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        branchError: ''
                                      }));
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        branch: e.target.value
                                      }));
                                    }
                                  }}
                                /> */}
                                  <input
                                    type="text"
                                    disabled
                                    className="inputStyle"
                                    placeholder="---"
                                    id="branch"
                                  />
                                  {errors?.branchError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.branchError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Account Name
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <TextField
                                  disabled
                                  {...register('accountName', {})}
                                  InputProps={{
                                    style: { fontSize: '12px', height: '2.25rem' }
                                  }}
                                  id="accountName"
                                  size="small"
                                  // style={TextFieldStyle}
                                  fullWidth
                                  placeholder="---"
                                  variant="outlined"
                                  // value={employeeInformation?.accountName}
                                  onChange={(e) => {
                                    setErrors((prev) => ({
                                      ...prev,
                                      accountNameError: ''
                                    }));
                                    setEmployeeInformation((prev) => ({
                                      ...prev,
                                      accountName: e.target.value
                                    }));
                                  }}
                                /> */}
                                  <input
                                    type="text"
                                    disabled
                                    className="inputStyle"
                                    placeholder="---"
                                    id="accountName"
                                  />
                                  {errors?.accountNameError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.accountNameError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  Account Number
                                </Typography>
                                <FormControl fullWidth>
                                  {/* <TextField
                                  disabled
                                  {...register('accountNumber', {})}
                                  InputProps={{
                                    style: { fontSize: '12px', height: '2.25rem' }
                                  }}
                                  id="accountNumber"
                                  size="small"
                                  // style={TextFieldStyle}
                                  fullWidth
                                  type="number"
                                  placeholder="---"
                                  variant="outlined"
                                  // value={Number(employeeInformation?.accountNumber)}
                                  onChange={(e) => {
                                    if (e.target.value.length < 31) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        accountNumberError: ''
                                      }));
                                      setEmployeeInformation((prev) => ({
                                        ...prev,
                                        accountNumber: e.target.value
                                      }));
                                    }
                                  }}
                                /> */}
                                  <input
                                    type="text"
                                    disabled
                                    className="inputStyle"
                                    placeholder="---"
                                    id="accountNumber"
                                  />
                                  {errors?.accountNumberError && (
                                    <Typography
                                      style={{
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        fontSize: '11px'
                                      }}
                                      color="red"
                                    >
                                      {errors?.accountNumberError}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandUserAccountDetails(
                                !isExpandUserAccountDetails
                              )
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandUserAccountDetails
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'7'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'User Account Details'}
                              </Typography>
                            </div>
                            {isExpandUserAccountDetails ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandUserAccountDetails ? (
                            <Grid
                              container
                              spacing={2}
                              sx={{ p: 1, pr: 2, mb: '1rem' }}
                            >
                              <Grid item xs={12}>
                                <Typography
                                  color="GrayText"
                                  style={{ fontSize: '13px' }}
                                >
                                  User Role
                                </Typography>
                                {!isEdit ? (
                                  <TextField
                                    id="role-view"
                                    disabled={!isEdit}
                                    inputProps={{ style: { fontSize: '13px' } }}
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    value={employeeInformation?.role.replace(
                                      /,/g,
                                      ', '
                                    )}
                                  />
                                ) : (
                                  <Multiselect
                                    {...register('role', {})}
                                    disable={
                                      // disables the whole input if needed
                                      !isEdit ||
                                      fields.some(
                                        (field) =>
                                          field.name === 'User Role' &&
                                          !field.edit
                                      )
                                    }
                                    className="user-role-multi-select"
                                    style={{
                                      multiselectContainer: {
                                        width: '100%'
                                      }
                                    }}
                                    selectedValues={setSelectedRoles()}
                                    id="role"
                                    placeholder={'Select User Role'}
                                    options={userRoles.map((role) => ({
                                      ...role,
                                      disabled: role.name === "General User"
                                    }))}
                                    onSelect={onSelect}
                                    onRemove={(selectedList, removedItem) => {
                                      if (removedItem.name === "General User") return;
                                      onRemove(selectedList, removedItem);
                                    }}
                                    displayValue="name"
                                  />
                                )}
                                {errors?.roleError && (
                                  <Typography
                                    style={{
                                      paddingRight: 15,
                                      fontSize: '11px'
                                    }}
                                    color="red"
                                  >
                                    {errors?.roleError}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}
                          <CustomTableRow
                            onClick={() => setIsExpandSkills(!isExpandSkills)}
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandSkills
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'8'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Skills'}
                              </Typography>
                            </div>
                            {isExpandSkills ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandSkills ? (
                            <Grid style={{ marginBottom: '1rem' }}>
                              <Grid
                                display="flex"
                                justifyContent="between"
                                container
                                style={{ marginTop: '1rem' }}
                              >
                                {isEdit && (
                                  <Button
                                    id="btn-toggleSkillsAdd"
                                    size="small"
                                    onClick={() => toggleSkillsAdd()}
                                    sx={{ ml: 'auto', mr: 1 }}
                                    style={{
                                      height: '2rem',
                                      fontSize: '12px',
                                      fontWeight: 'normal'
                                    }}
                                    variant="outlined"
                                  >
                                    Add More
                                  </Button>
                                )}
                                <SkillsAddModal
                                  toggle={toggleSkillsAdd}
                                  employeeId={employeeId}
                                  open={openSkillAddModal}
                                  getSkillData={getSkillData}
                                  skillsSet={skillsSet}
                                />
                              </Grid>
                              <Grid container spacing={2} sx={{ p: 1 }}>
                                {skillsSet?.length > 0 && (
                                  <Grid
                                    display="flex"
                                    alignItems="center"
                                    item
                                    xs={12}
                                  >
                                    <Grid item xs={6}>
                                      <Typography
                                        fontWeight="light"
                                        variant="h5"
                                      >
                                        Skill
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography
                                        fontWeight="light"
                                        style={{
                                          paddingLeft: 10,
                                          paddingRight: 15
                                        }}
                                        variant="h5"
                                      >
                                        Level
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                )}
                                {skillsSet?.length > 0 &&
                                  skillsSet.map((skill) => (
                                    <Grid
                                      display="flex"
                                      style={{ marginTop: '0.75rem' }}
                                      alignItems="center"
                                      item
                                      xs={12}
                                      key={skill?.skill}
                                    >
                                      <Grid item xs={6}>
                                        <FormControl fullWidth>
                                          <TextField
                                            id="emp-skill"
                                            inputProps={{
                                              style: { fontSize: '13px' }
                                            }}
                                            disabled
                                            size="small"
                                            fullWidth
                                            variant="outlined"
                                            value={skill?.skill}
                                            aria-readonly
                                          />
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <StyledRating
                                          id="emp-skillLevel"
                                          readOnly
                                          sx={{ ml: 1 }}
                                          name="customized-color"
                                          value={skill?.level}
                                          precision={1}
                                          icon={
                                            <CircleIcon
                                              style={{ fontSize: '14px' }}
                                            />
                                          }
                                          emptyIcon={
                                            <CircleIcon
                                              style={{ fontSize: '14px' }}
                                            />
                                          }
                                        />
                                      </Grid>
                                      {isEdit && (
                                        <Grid
                                          display="flex"
                                          justifyContent="end"
                                          item
                                          xs={2}
                                        >
                                          <CancelIcon
                                            id="btn-toggleConfirmation"
                                            sx={{ mr: 3, cursor: 'pointer' }}
                                            fontSize="small"
                                            color="action"
                                            onClick={() =>
                                              toggleConfirmation({
                                                skillName: skill.skill,
                                                employeeId: employeeId
                                              })
                                            }
                                          />
                                        </Grid>
                                      )}
                                    </Grid>
                                  ))}
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              style={{
                                height: '1rem',
                                borderLeft: '1px solid #D5DBDB',
                                marginLeft: '1.3rem'
                              }}
                            ></Grid>
                          )}

                          {/* ADD THE DOCUMENT ACKNOWLEDGEMENT SECTION HERE */}
                          <CustomTableRow
                            onClick={() =>
                              setIsExpandAcknowledgement(
                                !isExpandAcknowledgement
                              )
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Typography
                                style={{
                                  color: 'white',
                                  fontWeight: '700',
                                  fontSize: '11px',
                                  marginLeft: '0.5rem',
                                  marginRight: '1rem',
                                  padding: '4px 9px',
                                  borderRadius: '50%',
                                  background: isExpandAcknowledgement
                                    ? '#5569ff'
                                    : '#A6ACAF'
                                }}
                              >
                                {'9'}
                              </Typography>
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Document Acknowledgement'}
                              </Typography>
                            </div>
                            {isExpandAcknowledgement ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandAcknowledgement && (
                            <Grid
                              style={{ marginBottom: '1rem', padding: '1rem' }}
                            >
                              {ackLoading ? (
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  p={4}
                                >
                                  <CircularProgress />
                                </Box>
                              ) : (
                                <AcknowledgementTask
                                  title="Document Acknowledgement"
                                  dueDate={
                                    ackTask?.expectedCompletionAt ||
                                    lastKnownAckDueDate ||
                                    null
                                  }
                                  timeLeft={timeLeft}
                                  status={(() => {
                                    switch (
                                      (ackTask?.status || '').toUpperCase()
                                    ) {
                                      case 'COMPLETED':
                                        return 'Completed';
                                      case 'IN_PROGRESS':
                                        return 'In Progress';
                                      case 'ON_HOLD':
                                        return 'On Hold';
                                      default:
                                        return 'To Do';
                                    }
                                  })()}
                                  items={ackItems.map((item) => ({
                                    id: item.id,
                                    label: item.name,
                                    checked: item.acknowledged,
                                    viewUrl: item.documentUrl
                                  }))}
                                  initialComment={ackComment}
                                  readOnly={isAckReadOnly}
                                  saving={ackSaving || ackStatusUpdating}
                                  onSave={handleAcknowledgementSave}
                                  onClear={handleAcknowledgementClear}
                                  onStatusChange={
                                    handleAcknowledgementStatusChange
                                  }
                                />
                              )}
                            </Grid>
                          )}
                          {isEdit && (
                            <Grid
                              container
                              style={{
                                justifyContent: 'flex-end',
                                display: 'flex'
                              }}
                            >
                              <Button
                                type="button"
                                onClick={() => {
                                  navigate('/employees');
                                  setIsChangeStartDate(false);
                                  setIsChangeEndDate(false);
                                }}
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal'
                                }}
                                sx={{ marginRight: 2, mb: 1, mt: 2 }}
                                variant="outlined"
                                id="btn-navigate-employees"
                              >
                                Cancel
                              </Button>
                              <Button
                                disabled={isLoading}
                                className={isLoading ? 'loading' : ''}
                                type="submit"
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal'
                                }}
                                sx={{ marginRight: 2, mb: 1, mt: 2 }}
                                variant="contained"
                                id="btn-onSubmit"
                              >
                                Update
                              </Button>
                            </Grid>
                          )}
                          <Divider style={{ marginTop: '2rem' }} />
                          <CustomTableRow
                            style={{ marginTop: '1rem' }}
                            onClick={() =>
                              setIsExpandFeedbacks(!isExpandFeedbacks)
                            }
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <FeedbackIcon
                                style={{
                                  color: isExpandFeedbacks
                                    ? '#5569ff'
                                    : '#A6ACAF',
                                  fontWeight: '700',
                                  fontSize: '25px',
                                  marginLeft: '12px',
                                  marginRight: '1rem'
                                }}
                              />
                              <Typography
                                style={{
                                  color: '#232C68',
                                  fontWeight: '700',
                                  fontSize: '12px'
                                }}
                              >
                                {'Feedbacks'}
                              </Typography>
                            </div>
                            {isExpandFeedbacks ? (
                              <ExpandLessIcon style={{ fontSize: '27px' }} />
                            ) : (
                              <ExpandMoreIcon style={{ fontSize: '27px' }} />
                            )}
                          </CustomTableRow>
                          {isExpandFeedbacks && (
                            <>
                              {resignationDetails != null ? (
                                <>
                                  <Grid
                                    container
                                    style={{
                                      justifyContent: 'flex-end',
                                      display: 'flex'
                                    }}
                                  >
                                    <Grid item xs={12}>
                                      <p
                                        style={{
                                          marginBottom: 0,
                                          fontSize: '0.8rem'
                                        }}
                                      >
                                        <b>
                                          {
                                            resignationDetails.resigningEmployeeName
                                          }{' '}
                                        </b>
                                        - {resignationDetails.resignationDate}{' '}
                                        on resignation
                                      </p>
                                      <Box component="span">
                                        <p
                                          style={{
                                            padding: 5,
                                            border: '1px solid',
                                            color: 'gray',
                                            background: '#F9FBFF',
                                            fontSize: '0.8rem',
                                            marginRight: '1.5rem'
                                          }}
                                        >
                                          {
                                            resignationDetails.resignationFeedback
                                          }
                                        </p>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </>
                              ) : (
                                <> </>
                              )}
                              <Grid
                                container
                                style={{
                                  justifyContent: 'flex-end',
                                  display: 'flex'
                                }}
                              >
                                {reversedDesignation.map(
                                  (des) =>
                                    des.feedback && (
                                      <Grid item xs={12}>
                                        <p
                                          style={{
                                            marginBottom: 0,
                                            fontSize: '0.8rem'
                                          }}
                                        >
                                          <b>{des.promotedEmployeeName} </b>-{' '}
                                          {des.promotedDate}
                                        </p>
                                        <Box component="span">
                                          <p
                                            style={{
                                              padding: 5,
                                              border: '1px solid',
                                              color: 'gray',
                                              background: '#F9FBFF',
                                              fontSize: '0.8rem',
                                              marginRight: '1.5rem'
                                            }}
                                          >
                                            {des.feedback}
                                          </p>
                                        </Box>
                                      </Grid>
                                    )
                                )}
                              </Grid>
                            </>
                          )}
                        </form>
                      </Grid>
                    </Grid>
                  </Card>
                )}
                {tabValue === 2 && <EmployeeProjectDetails />}
                {tabValue === 3 && <EmployeeLeaveSection />}
                {tabValue === 4 && <ExamResults />}
                {tabValue === 5 && <ViewEventAttendee />}
              </Box>
            </Card>
          </Grid>
        </Grid>
        <SnackBarOld />
      </Container>
      <ConfirmationModal
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure want to remove this skill from the employee?`}
        onConfirm={() =>
          deleteSkills({
            skillName: deleteData.skillName,
            employeeId: deleteData.employeeId
          })
        }
        noToggle={() => setOpenConfirmation(false)}
        isLoading={isLoading}
      />
      <UnAuthorizedModal
        open={unauthorized}
        message={`Your role has changed. Please log in again.`}
      />
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </>
  );
};

export default EmployeeEditForm;
